import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/app.css';
import App from './components/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('wrapper')
);
